import { Link } from 'react-router-dom';
import { Post } from '../../../lib/supabase';

const mockLatest = [
  {
    slug: 'cursor-composer-tips-2026',
    title: 'Cursor Composerで長い実装を分割する方法——コンテキスト切れを防ぐ3つの工夫',
    excerpt: '長い実装をAIに任せると途中でコンテキストが切れる。その対策として試した分割戦略を整理した。',
    category: 'AIツール活用',
    categorySlug: 'ai-creation',
    date: '2026.04.01',
  },
  {
    slug: 'spec-driven-development-intro',
    title: '仕様書ファーストで開発する——AIに「何を作るか」を先に伝える設計',
    excerpt: 'コードを書く前に仕様書を作ると、AIとのやり取りが劇的に変わる。その具体的な手順と効果。',
    category: '制作フロー',
    categorySlug: 'build-log',
    date: '2026.03.25',
  },
  {
    slug: 'claude-vs-chatgpt-coding',
    title: 'ClaudeとChatGPTをコーディングで使い比べた——得意・不得意の違いが見えてきた',
    excerpt: '同じタスクを両方に投げて比較した。どちらが何に向いているか、実感ベースでまとめる。',
    category: '比較検証',
    categorySlug: 'productivity',
    date: '2026.03.18',
  },
  {
    slug: 'prompt-template-for-ui',
    title: 'UIコンポーネントを作るときのプロンプトテンプレートを公開する',
    excerpt: '何度も使い回せるプロンプトの型を作った。Reactコンポーネント生成に特化したバージョン。',
    category: 'プロンプト・仕様書',
    categorySlug: 'productivity',
    date: '2026.03.10',
  },
  {
    slug: 'readdy-site-week1-log',
    title: 'Readdy.aiでブログを作った最初の7日間——判断・迷い・失敗の全記録',
    excerpt: 'ゼロからサイトを立ち上げた1週間。何を決めて、何で詰まって、どう解決したかを全部書く。',
    category: '運営メモ',
    categorySlug: 'build-log',
    date: '2026.03.05',
  },
];

interface LatestArticlesProps {
  posts: Post[];
}

export function LatestArticles({ posts }: LatestArticlesProps) {
  const articles = posts.length > 0
    ? posts.slice(0, 5).map((p) => ({
        slug: p.slug,
        title: p.title,
        excerpt: p.excerpt || '',
        category: p.category || '',
        categorySlug: p.category_slug || '',
        date: p.published_at ? new Date(p.published_at).toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '.') : '',
      }))
    : mockLatest;

  return (
    <section className="py-14 sm:py-20 bg-[#F5EFE6]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">

        {/* Section header */}
        <div className="flex items-baseline justify-between mb-8 sm:mb-10">
          <div>
            <p
              className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-2"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              Latest
            </p>
            <h2
              className="text-xl sm:text-2xl font-bold text-[#2C2416]"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              新着記事
            </h2>
          </div>
          <Link
            to="/articles"
            className="text-xs text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            すべて見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Article list */}
        <div className="bg-[#FDFAF6] border border-[#E8E0D5] rounded-lg overflow-hidden">
          {articles.map((article, index) => (
            <article key={article.slug}>
              <Link
                to={`/articles/${article.slug}`}
                className="block px-5 sm:px-6 py-5 hover:bg-[#F8F3EC] transition-colors cursor-pointer group"
              >
                <div className="flex items-center gap-2 mb-2">
                  <span
                    className="text-xs font-medium text-[#5B7B6F]"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {article.category}
                  </span>
                  <span className="text-[#D4C9BE] text-xs">·</span>
                  <span
                    className="text-xs text-[#9A8E84]"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {article.date}
                  </span>
                </div>
                <h3
                  className="text-sm sm:text-base font-semibold text-[#2C2416] leading-snug mb-1.5 group-hover:text-[#5B7B6F] transition-colors"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {article.title}
                </h3>
                <p
                  className="text-xs sm:text-sm text-[#7A6E62] leading-relaxed line-clamp-1"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {article.excerpt}
                </p>
              </Link>
              {index < articles.length - 1 && (
                <div className="border-t border-[#EDE7DF] mx-5 sm:mx-6"></div>
              )}
            </article>
          ))}
        </div>

        {/* More link */}
        <div className="mt-6 text-center">
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 text-sm text-[#5B7B6F] hover:text-[#2C2416] transition-colors cursor-pointer"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            記事をもっと見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

      </div>
    </section>
  );
}
